import React from 'react'
import styled from 'styled-components'
import { array } from 'prop-types'
import { Box, Text, Image } from 'rebass'
import { rem } from 'polished'
import CountUp from 'react-countup'
import citygateTheme from '../../theme/'
import { Watch } from 'scrollmonitor-react'
import { media } from '../../utils/style'
import buildImageUrl from '../../../lib/media-url-maker'

const SpecDetail = styled(({ theme, keyposition, icon, ...rest }) => (
  <Box {...rest} />
))`
  position: relative;
  ${(props) =>
    !props.icon && props.keyposition % 2
      ? `border-left: 2px ${props.theme.colors.white_op30} solid;`
      : ''};
  ${(props) => (props.icon ? 'width: 100%;' : '')};
  span {
    ${media.MediumScreenUp`
    width: 50%;
    margin: 0 auto;
    display: block;
    `};
    ${media.LargeScreenUp`
    width: 100%;
    `};
  }
  &::after {
    ${(props) => (props.icon && props.keyposition % 2 ? `content: ''` : '')};
    position: absolute;
    top: -35%;
    ${media.MediumScreenUp`
    top: -45%;
    `};
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${(props) => props.theme.colors.white_op30};
  }
  svg {
    margin-left: 10%;
    float: left;
    ${media.MediumScreenUp`
      margin-left: 15%;
    `};
  }
`

const SpecImage = styled(Image)`
  height: 100%;
  width: 100%;
`

const SpecNumber = styled(Text)`
  position: relative;
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    display: block;
  }
`

class ContentBrandDerivativeSpec extends React.Component {
  constructor(props) {
    super(props)
    this.isCountersAnimated = false
  }

  render() {
    let specMarkup = []
    this.props.spec.forEach((spec, key) => {
      if (spec.image) {
        specMarkup.push(
          <SpecImage
            mb={0}
            mt={[50, null, 0]}
            src={buildImageUrl({ resource: spec.image })}
            key={`cbdsd:${spec.image.x1}`}
          />
        )
      } else {
        specMarkup.push(
          <SpecDetail
            width={1 / 2}
            mt={[50, null, 0]}
            mb={[0, null, 70]}
            keyposition={key}
            icon={spec.icon}
            key={`${spec.value}:${spec.decimal}:${spec.label}`}
          >
            {!spec.icon && (
              <Text bold fontSize={2}>
                {spec.label}
              </Text>
            )}
            {spec.icon && (
              <span>
                {spec.icon}
                <Text bold fontSize={[10, null, 11]} mb={12}>
                  {spec.label}
                </Text>
              </span>
            )}
            <SpecNumber
              bold
              fontSize={[9, rem(70), rem(80)]}
              py={[30, null, 50]}
            >
              {!spec.value && <span>NA</span>}

              {spec.value &&
                Number.isFinite(spec.value) &&
                (this.props.isInViewport || this.props.isAboveViewport) && (
                  <CountUp
                    start={0}
                    end={spec.value}
                    decimals={spec.decimal}
                    useGrouping
                  />
                )}
              {spec.value && !Number.isFinite(spec.value) && (
                <span>{spec.value}</span>
              )}
            </SpecNumber>
            <span>
              <Text
                as={spec.lowerData ? 'span' : 'p'}
                bold
                pt={12}
                color={citygateTheme.colors.blue_light_op50}
              >
                {spec.suffix}
              </Text>
            </span>
          </SpecDetail>
        )
      }
    })
    return specMarkup.length > 0 ? specMarkup : <div />
  }
}

ContentBrandDerivativeSpec.defaultProps = {
  spec: []
}

ContentBrandDerivativeSpec.propTypes = {
  spec: array
}

export default Watch(ContentBrandDerivativeSpec)
